import React, { useState } from "react";
import {
    IconButton,
    Menu,
    MenuItem,
    Dialog,
    DialogTitle,
    DialogActions,
    Button,
    Stack,
} from "@mui/material";
import { useNavigate } from "react-router";
import { appSession } from "../TR3AD.ts";

function AppHeader() {

    const navigate = useNavigate();
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const [confirmOpen, setConfirmOpen] = useState(false);

    // const [query, setQuery] = useState("");

    function handleAccountMenu(event: React.MouseEvent<HTMLElement>) {
        setAnchorEl(event.currentTarget);
    }
    function handleCloseMenu() {
        setAnchorEl(null);
    }

    function handleLogout() {
        setConfirmOpen(true);
        handleCloseMenu();
    }

    function handleConfirmLogout() {
        setConfirmOpen(false);
        appSession.logout((success: boolean) => {
            if (success) {
                navigate('/login');
            }
        });
    }

    function handleCancelLogout() {
        setConfirmOpen(false);
    }

    function onShowAlerts()
    {
        //TODO: Highlight the left navigation
        navigate('/alerts');
    }

    function onShowHelp()
    {
        navigate('/help');
    }

    return (
        <Stack direction="row" padding={1} spacing={0} justifyContent="space-between" alignItems="center" width="100%">
            <Stack direction="row" spacing={1} alignItems="center">
                {/*<img src="/tr3ad_logo.png" height={32} />*/}
                {/*<Typography variant="h5">TR3AD</Typography>*/}
                <img src="/tr3ad_logo.svg" height={32} />
                <img src="/tr3ad_intelligence_name_only.svg" height={32} />
            </Stack>
            <Stack direction="row" spacing={1}>
                <IconButton title="Alerts" onClick={onShowAlerts}>
                    <img src="/images/alerts.svg" width={24} />
                </IconButton>
                <IconButton title="User Account" onClick={handleAccountMenu}>
                    <img src="/images/account.svg" width={24} />
                </IconButton>
                <IconButton title="Help" onClick={onShowHelp}>
                    <img src="/images/help.svg" width={24} />
                </IconButton>
                <Menu
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={handleCloseMenu}
                    anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "right",
                    }}
                    transformOrigin={{
                        vertical: "top",
                        horizontal: "right",
                    }}
                >
                    <MenuItem onClick={handleLogout}>Logout</MenuItem>
                </Menu>
                <Dialog open={confirmOpen} onClose={handleCancelLogout}>
                    <DialogTitle>Are you sure you want to logout?</DialogTitle>
                    <DialogActions>
                        <Button onClick={handleCancelLogout} color="primary" variant="outlined">
                            Cancel
                        </Button>
                        <Button onClick={handleConfirmLogout} color="error" variant="contained">
                            Logout
                        </Button>
                    </DialogActions>
                </Dialog>
            </Stack>
        </Stack>
    )
}

export default AppHeader;
